<template>
  <div class="cusTopMenu">
    <!-- 展开图标和logo -->
    <slot name="left"></slot>

    <!-- 导航菜单 -->
    <slot name="middle"></slot>

    <!-- 返回 -->
    <slot name="icon-home">

    </slot>

    <!-- 搜索框 -->
    <slot name="nav-input"></slot>
    <!-- 换肤图标 -->
    <div class="tag right oms-theme">
      <i class="iconfont icon-skin" />
      <el-color-picker v-model="defaultColor" @change="colorPick" :predefine="predefineColors" class="oms-skin-pick"></el-color-picker>
    </div>
    <!-- 全屏图标 -->
    <div class="tag right">
      <i class="iconfont icon-fullscreen-expand" @click="screenfullFn" v-if="!isFullscreen" />
      <i class="iconfont icon-fullscreen-shrink" @click="screenfullFn" v-if="isFullscreen" />
    </div>
    <!-- 任务图标 -->
    <slot name="icon-task"></slot>

    <!-- 个人设置 -->
    <slot name="icon-person"></slot>
  </div>
</template>

<script>
import screenfull from 'screenfull';
export default {
  name: "NavigatorVertical",
  components: {},
  data () {
    return {
      isFullscreen: false,
      defaultColor: '#409EFF',
      predefineColors: [
        // '#f1b8f1', // 马卡龙粉
        '#FFC0CB',
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        // '#00cex1',
        '#3870c1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        // 'hsv(51, 100, 98)',
        // 'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      ColorMatch: {
        // "#F1B8F1":"#b8f1ed",
        "#FFC0CB":"#8A2BE2", // 粉-天蓝
        // "#FF4500":"#3870C1", // 红-蓝
        // "#FF8C00"
        // "#FFD700"
        // "#90EE90"
        // "#3870C1"
        // "#1E90FF"
        // "#C71585"
        // "#FF4500"
        // "#FF7800"
        // "#00BABD"
        // "#1F93FF"
        // "#C71585"
      },
    }
  },
  created() {
    this.setDefauleTheme()
  },
  mounted () {
    this.initScreenFull()
    this.navFold()
  },
  beforeDestroy () {
    this.destroyScreenFull()
  },
  methods: {
    /* ---------------- 换肤处理Start ---------------- */
    setDefauleTheme(obj) {
      let initTheme = obj;
      const getCacheTheme = localStorage.getItem('cacheTheme')
      if (getCacheTheme) {
        initTheme = JSON.parse(getCacheTheme)
      } else {
        initTheme = {
          '--b1-color': "#284F87",
          '--b1-color_q1': " #ABCDEF",
          '--b1-color_x1': "#053A87",
          '--b2-color': "hsl(10.4, 95%, 44.6%)",
          '--b2-color_q1': "hsl(10.4, 95%, 53.5%)",
          '--b2-color_x1': "hsl(10.4, 95%, 35.7%)",
          '--t-text': "#fff"
        }
      }
      for (const it of Object.entries(initTheme)) {
        this.Co(it[0],it[1])
      }
    },
    Co(x,y) {
        document.documentElement.style.setProperty(x,y);
    },
    colorPick(val) {
      this.defaultColor = val
      console.log('-----pick::', val);
      if (!val) {
        // 点击'清空'时：
        localStorage.setItem('cacheTheme', '')
        this.setDefauleTheme()
        return
      }
      // 颜色深度处理
      const Color = require('color');
      let b1, b1x1, b1q1, b2, text;
      b1 = Color(val)
      const {r, g, b} = b1.object()

      b1q1 = b1.lighten(0.1).hex()
      b1x1 = b1.saturate(0.7).darken(0.2).hex()
      b2 = b1.saturate(0.75).rotate(155).lighten(0.3); // 逆时针

      if(r*0.299 + g*0.578 + b*0.114 >= 172){ // 浅色 192
        text = "#17233d"
        b2 = b1.darken(0.4).rotate(-80); // .desaturate(0.75)
      } else {
        text = "#fff"
      }
      let formatColor = [];
      for (const it of this.predefineColors) {
        formatColor.push(Color(it).hex())
      }
      if (formatColor.includes(val) && this.ColorMatch[val]) {
        b2 = this.ColorMatch[val]
      }
      const cacheTheme = {
        "--b1-color": val,
        "--b1-color_x1": b1x1,
        // "--b1-color_q1": "#ABCDEF",
        "--b2-color": b2,
        "--b2-color_q1": Color(b2).lighten(0.2),
        "--b2-color_x1": Color(b2).darken(0.2),
        "--t-text": text
      }
      // this.setDefauleTheme(cacheTheme)
      for (const it of Object.entries(cacheTheme)) {
        this.Co(it[0],it[1])
      }
      localStorage.setItem('cacheTheme', JSON.stringify(cacheTheme))

      /* for (const [x,y] of Object.entries(cacheTheme)) {
        const cur = getComputedStyle(document.documentElement).getPropertyValue(x)
        cacheTheme[x] = cur
      } */

      this.Co("--color1","#87CEEB");
      this.Co("--color2",b2);
      this.Co("--color3",b1.darken(0.4).rotate(-90));
    },
    /* ---------------- 换肤处理End ---------------- */
    screenfullFn () {
      console.log("screenfull", screenfull)
      if (!screenfull.enabled) {
        this.$message.warning("您的浏览器暂时不支持全屏")
        return false
      }
      screenfull.toggle()
    },
    initScreenFull () {
      if (screenfull.enabled) {
        screenfull.on('change', this.change)
      }
    },
    change () {
      this.isFullscreen = screenfull.isFullscreen
    },
    destroyScreenFull () {
      if (screenfull.enabled) {
        screenfull.off('change', this.change)
      }
    },
    navFold() {
      this.$nextTick(() => {
        OMS.cssHandleUtils.navFoldPosition();
        // 监听框架导航折叠Icon
        $('.r3-content-Navigator .navigator .left img.trigger').on('click', () => {
          OMS.cssHandleUtils.navFoldPosition();
          OMS.cssHandleUtils.refreshAgTableHeight() // 渲染定制列表页面ag表格
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.oms-theme {
  position: relative;
  .oms-skin-pick {
    position: absolute;
    left: 4px;
    top: 4px;
    opacity: 0;
  }
  /deep/ .el-color-dropdown.el-color-picker__panel {
    top: 50px;
  }
}

</style>
